<template>
  <span>
    <button v-b-modal="`modal-${id}`" v-bind="$attrs" :class="classProp" v-on="$listeners"><i class="far fa-images"></i></button>

    <b-modal :id="`modal-${id}`" class='text-center' hide-footer hide-header>

      <b-overlay :show="uploading" no-center>
        <div v-if="type.indexOf('upload') > -1">
          <b-form-file @input="upload_image" accept="image/*"  v-model="file" placeholder="Choose an image or drop it here..." drop-placeholder="Drop image here..."></b-form-file>
        </div>

        <div v-if="type.indexOf('icon') > -1">
          <hr v-if="type.indexOf('upload') > -1">

          <b-input-group class="mb-4">
            <b-form-input v-model="icon_search_term" placeholder="Search for icons"  @change="icon_search(1)"></b-form-input>
            <b-input-group-append>
              <LoadingButton :loading="loading">Search</LoadingButton>
            </b-input-group-append>
          </b-input-group>

          <b-card-group deck>
            <b-card v-for='result in icon_results' v-bind:key="result.id" no-body :img-src="result.preview_url_84" style="min-width: 7rem; max-width: 7rem; margin: auto;" class="mb-4 image-select" @click="selected_image_url = result.preview_url"></b-card>
          </b-card-group>
        </div>
        <div v-if="type.indexOf('image') > -1">
          <hr v-if="type.indexOf('upload') > -1 || type.indexOf('icon') > -1">

          <b-input-group class="mb-4">
            <b-form-input v-model="search_term" placeholder="Search for images"  @change="search(1)"></b-form-input>
            <b-input-group-append>
              <LoadingButton :loading="loading_image">Search</LoadingButton>
            </b-input-group-append>
          </b-input-group>

          <b-card-group deck>
            <b-card v-for='result in results' v-bind:key="result.id" no-body :img-src="result.urls.thumb" style="min-width: 14rem; max-width: 14rem; margin: auto;" class="mb-4 image-select" @click="select_image(result.urls.regular)"></b-card>
          </b-card-group>

          <LoadingButton :loading="loading" v-if="has_more" @click="load_more" class="text-center">Load more</LoadingButton>
        </div>
        <div v-if="type.indexOf('fa_icon') > -1">
          <hr v-if="type.indexOf('upload') > -1 || type.indexOf('icon') > -1 || type.indexOf('image') > -1">

          <b-input-group class="mb-4">
            <b-form-input v-model="fa_icon_term" placeholder="Search for icons"  @change="fa_icon_search(1)"></b-form-input>
            <b-input-group-append>
              <LoadingButton :loading="loading_icon">Search</LoadingButton>
            </b-input-group-append>
          </b-input-group>

          <b-card-group deck>
            <b-card v-for='(result, index) in fa_icon_results' v-bind:key="`${result}-${index}`" no-body style="min-width: 4rem; max-width: 4rem; margin: auto;" class="mb-4 image-select p-1 text-center" @click="select_icon(result)">
              <span style="font-size: 3em;"><i :class="result"></i></span>
            </b-card>
          </b-card-group>
        </div>
      </b-overlay>
    </b-modal>
  </span>
</template>

<script>
// const unsplash = new Unsplash({applicationId: "alXPMfbCx87p57yvBd1tsF3zuz5TTAhXkNngfoH4EFg", secret: "4zkXFQLYWXWlQVjebrf-jWvO7QMS3UIIgOVIlnkUrnQ"})

import { db, storage } from '@/main.js'
import api from '@/lib/api.js'

import 'whatwg-fetch'
import fontAwesomeSearch from 'font-awesome-search'
import Unsplash, { toJson } from "unsplash-js";
const unsplash = new Unsplash({accessKey: "alXPMfbCx87p57yvBd1tsF3zuz5TTAhXkNngfoH4EFg"}) // TODO // TODO access to only 50 per hour
const icon_search = fontAwesomeSearch({fontStyles: ['regular']})

export default {
  name: 'ImageSearch',
  props: ['action', 'classProp', 'type', 'is_small'],
  data() {
    return {
      id: db.collection('random').doc().id,
      results: [],
      icon_results: [],
      fa_icon_results: [],
      search_term: undefined,
      icon_search_term: undefined,
      fa_icon_term: undefined,
      page: 1,
      has_more: false,
      loading: false,
      file: null,
      selected_image_url: undefined,
      uploading: false,
      loading_image: false,
      loading_icon: false,
    }
  },
  watch: {
    selected_image_url: function(val) {
      this.search_term = undefined
      this.icon_search_term = undefined
      this.fa_icon_term = undefined
      this.page = 1
      this.results = []
      this.icon_results = []
      this.fa_icon_results = []
      this.has_more = false
      this.loading = false
      this.file = null
      this.uploading = false

      this.$bvModal.hide(`modal-${this.id}`)

      if (!val) {
        this.action(null)
      } else {
        this.action(val)
      }
    }
  },
  methods: {
    async fa_icon_search() {
      if (this.fa_icon_term.length < 2) {
        alert('Please enter a longer search term')
        return
      }

      this.loading_icon = true

      let results = await icon_search(this.fa_icon_term)
      this.fa_icon_results = results.slice(0, 100)
      this.loading_icon = false
    },
    async select_image(url) {
      this.uploading = true
      let blob = await window.fetch(url).then(r => r.blob())
      let dataUrl = await new Promise(resolve => {
        let reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })

      let id = db.collection('random').doc().id
      let snap = await storage.ref().child(`media/${id}.png`).putString(dataUrl, 'data_url', {'cacheControl': 'max-age=2628000, public', customMetadata: {small: this.is_small}})
      this.selected_image_url = `https://storage.googleapis.com/${this.config.firebase_config.storageBucket}/media/${id}.png`  // await snap.ref.getDownloadURL()

      this.uploading = false
    },
    async select_icon(icon) {
      this.uploading = true
      this.selected_image_url = `https://storage.googleapis.com/${this.config.firebase_config.storageBucket}/icons/regular/${icon.replace('far ', '').replace('fa-', '')}.svg`
      this.uploading = false
    },
    async icon_search() {
      if (!this.icon_search_term || this.icon_search_term.length < 2) {
        this.icon_results = []
        return
      }

      this.loading = true
      let results = await api.search_icon(this.icon_search_term)

      this.icon_results = results.data.icons
      this.loading = false

      console.log('results', results)
    },
    async upload_image(file) {
      if (!file) {
        return
      }

      this.uploading = true
      let id = db.collection('random').doc().id
      let snap = await storage.ref().child(`media/${id}.png`).put(file, {'cacheControl': 'max-age=2628000, public', customMetadata: {small: this.is_small}})
      let selected_image_url = `https://storage.googleapis.com/${this.config.firebase_config.storageBucket}/media/${id}.png` // await snap.ref.getDownloadURL()

      this.selected_image_url = selected_image_url
      this.uploading = false
    },
    async load_more() {
      this.page++
      this.search()
    },
    async search(page) {
      this.loading_image = true
      if (page) {
        this.page = page
      }

      this.loading = true
      if (this.search_term && this.search_term.length > 2) {
        console.log('searching', this.search_term)
        let results = await unsplash.search.photos(this.search_term, this.page, 16, {orientation: 'landscape'}).then(toJson)
        console.log(results)

        if (this.page == 1) {
          this.results = results.results
        } else {
          this.results = this.results.concat(results.results)
        }

        if (results.total > 0 && results.total_pages > this.page) {
          this.has_more = true
        } else {
          this.has_more = false
        }
      } else {
        this.results = []
      }

      this.loading = false
      this.loading_image = false
    }
  }
}
</script>

<style scoped>

.image-select:hover {
  opacity: 0.5;
  cursor: pointer;
}

</style>
